import { render, staticRenderFns } from "./PackageSettignsCreate.vue?vue&type=template&id=f9908e5c&scoped=true"
import script from "./PackageSettignsCreate.vue?vue&type=script&lang=js"
export * from "./PackageSettignsCreate.vue?vue&type=script&lang=js"
import style0 from "./PackageSettignsCreate.vue?vue&type=style&index=0&id=f9908e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9908e5c",
  null
  
)

export default component.exports